module.exports = __webpack_public_path__ + "static/media/bgMaquinaTejHomePC.40096fbe.jpg";